<template>

  <!-- Canceled (CANCELED) -->
  <order-list-data-table
      title="Canceled"
      defaultSortField="canceled_at"
      defaultSortOrder="dsc"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      :linkToLocations="true" />

</template>

<script>
import OrderListDataTable from '@/components/orders/OrderListDataTable'

export default {
  name: 'OrderListCanceledPage',

  components: {
    OrderListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Order#', value: 'order_number', width: '160px' },
        // { text: 'Provider', value: 'provider_alias' },
        // { text: 'Account', value: 'thirdparty_account_name' },
        { text: 'Brand', width: '140px', value: 'thirdparty_brand_name' },
        { text: 'Total', value: 'order_details.total' },
        { text: 'From', value: 'shipper.name' },
        { text: 'To', value: 'receiver.name' },
        { text: 'Canceled', value: 'canceled_at', align: 'center' },
        { text: 'Status', value: 'order_status' }
      ],
      status: ['CANCELED'],
      assocs: 'shipper,receiver,order_details,parent_order'
    }
  }
}
</script>

<style scoped>
</style>
